import { SpinnerStyled } from './Spinner.styles';

export interface SpinnerProps {}

export const Spinner = (props: SpinnerProps) => {
  return <SpinnerStyled></SpinnerStyled>;
};
